import { render } from "./ImageTextWide.vue?vue&type=template&id=9a487ece&scoped=true"
import script from "./ImageTextWide.vue?vue&type=script&lang=js"
export * from "./ImageTextWide.vue?vue&type=script&lang=js"

import "./ImageTextWide.vue?vue&type=style&index=0&id=9a487ece&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a487ece"]])

export default __exports__